import { useRef, useState } from "react";
import PropTypes from "prop-types";
import EntryForm from "../entry-form";
import styles from "./styles";
import Hero from "../../components/hero";
import CompetitionInfo from "../../components/competition-info";
import ImageGrid from "../../components/image-grid";
import SuccessResponse from "../../components/success-response";
import CompetitionClosed from "../../components/competition-closed";
import { getInitialFormStatus } from "../../utilities/competition-status";
import ASOSMastercardLogo from "../../assets/asos-mc-body-logo.svg";

export default function CompetitionLayout({ appConfig, ignoreCaptcha }) {
  const entryFormRef = useRef();
  const containerRef = useRef();
  const [formStatus, setFormStatus] = useState(getInitialFormStatus());

  function scrollToAnchor(anchor) {
    anchor?.current?.scrollIntoView({
      top: anchor.current.offsetTop,
      behavior: "smooth",
    });
  }

  const competitionClosed = formStatus === "closed";

  const renderEntryForm = () =>
    (!formStatus ||
      formStatus === "error" ||
      formStatus === "duplicateEmail") && (
      <EntryForm
        anchorRef={entryFormRef}
        appConfig={appConfig}
        setFormStatus={setFormStatus}
        formStatus={formStatus}
        ignoreCaptcha={ignoreCaptcha}
        scrollToTop={() => scrollToAnchor(containerRef)}
      />
    );

  return (
    <div className={styles.container} ref={containerRef}>
      <Hero
        scrollToAnchor={() => scrollToAnchor(entryFormRef)}
        competitionClosed={competitionClosed}
      />
      <div className={styles.logo}>
        <ASOSMastercardLogo
          aria-label="ASOS Mastercard Partnership logo"
          role="img"
        />
      </div>
      {competitionClosed ? <CompetitionClosed /> : <CompetitionInfo />}
      <ImageGrid />
      {renderEntryForm()}
      {formStatus === "success" && <SuccessResponse />}
    </div>
  );
}

CompetitionLayout.propTypes = {
  appConfig: PropTypes.shape({
    recaptchaSiteKey: PropTypes.string.isRequired,
  }),
  ignoreCaptcha: PropTypes.bool,
};

CompetitionLayout.defaultProps = {
  ignoreCaptcha: false,
};
